import React, {Component} from "react";
import {API_BASE_URL, API_KEY, LANGUAGE, MOVIE_POSTER_URL} from "../../services/const";
import CoversRow from './CoversRow';
import $ from 'jquery';
import './novidades.css';
import MovieDetails from "../sitestruct/movieDetails/MovieDetails";



class Novidades extends Component{

    /**
     * Class constructor
     * @param props
     */
    constructor(props){
        super(props);
        this.state = {} //schedules an update to a component state object. When state changes, the component responds rendering itself

        this.onclickmovie = this.onclickmovie.bind(this); //button action: show selected movie details (new page)
        this.onclickback = this.onclickback.bind(this);   //button action: go back (to previous page: Novidades or Filmes)

        this.showCovers();
    }


    /**
    * This method open selected movie from list and show the cover and details
    *
    * @param: id (movie ID)
    */
    onclickmovie(id){
        var movie = this.state.rows.find(x => parseInt(x.key) === id);    //convert to string movie ID to return the movie (something like "where" from mySQL)

        this.setState({
            showDetailPage: true,       //set the boolean var to true to open the details page
            selectedDetailMovie: movie  //If want open details page, this var (movie) carries all information about selected movie
        });
    }


    /**
    * This method allow to user return to previous page (to Novidades or Filmes, depends where user select film to show details)
    */
    onclickback(){
        this.setState({
            showDetailPage: false      //set the boolean var to false to close the details page
        });
    }


    /**
    * This method requires API all latest movies, store all information and show the movies covers to user select one to see
    */
    showCovers(){

        //jQuery syntax
        try{
            $.ajax({
                url: API_BASE_URL + '/movie/now_playing?api_key=' + API_KEY + '&language=' + LANGUAGE + '&page=1',  //url request to API
                success: (searchResults) => {
                    console.log("Fetch data from API");
                    const results = searchResults.results;    //get all raw results and store on var results
                    var coverRows = [];                       //this var coverRows is an array to store all movie covers

                    results.forEach( (movie) => {                                                                  //for each results do:
                        movie.poster_src = MOVIE_POSTER_URL + movie.poster_path;                                      //get the image url from API and append to another url to show image
                        const movieRow = <CoversRow key={movie.id} movie={movie} onclickcover={this.onclickmovie} />  //"send" to component CoversRow all covers with on click event

                        coverRows.push(movieRow);                                                                     //store on array, all movie covers
                    });

                    this.setState({ rows: coverRows }); //element (rows) for the "render"
                },
                error: (xhr, status, err) => {
                    console.error("Failed to try fetching API data");
                }
            });
        }catch(e){
            console.log(e);
        }

    }


    /**
     * This method render the information (data from previous functions) with HTML code
     * @returns Return page information inside HTML
     */
    render(){
        if(this.state.showDetailPage){
            return (<MovieDetails movieobj={this.state.selectedDetailMovie}   /* this state have all information about selected movie */
                                  onclickbacktofilms={this.onclickback}       /* image click event: call the function onclickback from component MovieDetails */
            /> );
        }else{
            return(
                <div>
                    <h1>Página Novidades</h1>
                    <p>Seleccione um filme que deseja ver, senta-te e desfruta!</p>
                    <div className="row">
                        {this.state.rows}
                    </div>
                </div>
            );
        }
    }

}

export default Novidades;
